var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_8734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.619 0H19.381C8.67715 0 0 8.67716 0 19.381V68.619C0 79.3228 8.67715 88 19.381 88H68.619C79.3229 88 88 79.3228 88 68.619V19.381C88 8.67716 79.3229 0 68.619 0Z",
    fill: "url(#paint0_linear_804_8734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9996 15.2336C35.4333 15.2337 27.2178 18.0681 21.1605 23.1135C15.1032 28.1588 11.7003 35.0017 11.7002 42.1369C11.708 46.778 13.1571 51.3384 15.9067 55.375C18.6562 59.4117 22.6127 62.7872 27.3917 65.1736C26.1189 68.0231 24.2099 70.6952 21.7439 73.0792C26.5261 72.2397 31.0153 70.4761 34.8621 67.9257C37.8281 68.6598 40.9054 69.0351 43.9996 69.0401C52.566 69.0401 60.7814 66.2056 66.8387 61.1603C72.896 56.115 76.299 49.272 76.2991 42.1369C76.299 35.0017 72.896 28.1588 66.8387 23.1135C60.7814 18.0681 52.566 15.2337 43.9996 15.2336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_804_8734",
    x1: 44.6984,
    y1: 82.1585,
    x2: 44.6984,
    y2: 10.9212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BF675"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_8734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsBig);
export default __webpack_public_path__ + "static/media/SMSBig.948490daa377fa6c86558e0871822627.svg";
export { ForwardRef as ReactComponent };